var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Banner',{staticClass:"banner",on:{"scroll":_vm.scroll}}),_c('Project',{staticClass:"project"}),_c('Video',{attrs:{"id":"video"}}),_c('News'),_c('Partner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }